export default __webpack_public_path__ + "static/media/cup.e11a0bfc.svg";